<script setup lang="ts">
import type { PropType } from 'vue'
import type { StopBus } from '~/types'
const props = defineProps({
  departure: {
    type: Object as PropType<StopBus>,
    required: true,
  },
})
const time = computed(() => useTimeDifference(props.departure))
const theoricTime = computed(() => !props.departure?.rt)
const lessOneMinute = computed(() => useLessThanOneMinute(props.departure))
const lessHalfMinute = computed(() => useLessThanHalfAMinute(props.departure))
</script>

<template>
  <div
    class="departure-card flex justify-between py-3 border-t border-vmcv-gray-dark"
  >
    <div class="flex space-x-4 md:space-x-8 items-center">
      <StopChip :stop="departure" />
      <div class="font-medium">
        {{ departure.destination }}
      </div>
    </div>
    <div class="flex space-x-2">
      <span v-if="theoricTime" class="font-semibold text-2xl text-vmcv-blue">
        ~
      </span>

      <span class="font-semibold text-2xl">
        <span
          v-if="lessOneMinute"
          :class="{
            'animate-blink': lessHalfMinute,
          }"
        >
          <SvgoIconVehicle class="w-6 h-6 text-vmcv-blue" />
        </span>
        <span v-else>{{ time }}</span>
      </span>
    </div>
  </div>
</template>
